module.exports = __webpack_public_path__ + "static/Nocturne-8b6c26924f7ecec33a32ddebc1b8b268.mp3";